export default __webpack_public_path__ + "static/media/OpenSea.0da82483.svg";